module.exports = __webpack_public_path__ + "static/media/Apple iPhone 5c Yellow.2e49e581.png";